<template>
  <v-card outlined :class="{'glance-grey': add, 'glance-green': !add && item.enabled, 'glance-red': !add && !item.enabled}" :style="cardStyle">
    <v-layout column justify-center align-center class="py-5">
      <template v-if="add">
        <v-icon x-large>mdi-plus</v-icon>
        <span>New Item</span>
      </template>
      
      <template v-else>
        <v-flex>
          <span class="grey--text text--darken-1 font-weight-medium display-1 mb-2">{{ item.title }}</span>
        </v-flex>
        <v-flex>
          <span class="display-2" :style="fontColor">{{ item.enabled ? 'Yes' : 'No' }}</span>
        </v-flex>
      </template>
      
    </v-layout>
  </v-card>
</template>

<script>
export default {
  props: {
    add: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
    },
    display: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  computed: {
    fontColor() {
      return { 'color': this.getColor(this.item.enabled) }
    },
    cardStyle() {
      return this.display ? null : {'cursor': 'pointer', 'min-height': '110px'}
    }
  },
  methods: {
    getColor(enabled) {
      return enabled ? '#3fe43c' : '#ff4c2c'
    }
  }
}
</script>